"use client";

import EnqueryForm from "@/components/forms/EnqueryForm";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Categories, SuccessMessageType, Tags } from "@/interface/types";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Link from "next/link";

const CmaFooter = () => {
  const [isformPopupOpen, setformPopupOpen] = useState(false);
  const [categories, setCategories] = useState<Categories[]>([]);
  const [tags, setTags] = useState<{ [key: string]: Tags[] }>({});
  const [activeItem, setActiveItem] = useState<string | null>(null);

  const closeformPopup = () => {
    setformPopupOpen(false);
  };

  const getCategories = async () => {
    try {
      const API_URL =
        "https://website-cms-backend-prod-154625965269.asia-south1.run.app/categories/?vertical=Accounting";
      const response = await axios.get(API_URL);
      const { status, data } = response;
      if (status === 200) {
        setCategories(data.Data);
        fetchTagsForCategories(data.Data);
      } else {
        console.warn("empty array");
      }
    } catch (error) {
      console.error("failed to fetch categories");
    }
  };

  const getTags = async (categorySlug: string) => {
    if (!categorySlug) {
      console.error("Category is required");
      return;
    }

    try {
      const API_URL = `https://website-cms-backend-prod-154625965269.asia-south1.run.app/tags?category=${categorySlug}`;
      const response = await axios.get(API_URL);
      const { status, data } = response;
      if (status === 200 && data.Data.length > 0) {
        return data.Data;
      } else {
        return [];
      }
    } catch (error) {
      console.error(
        `Failed to fetch tags for category: ${categorySlug}`,
        error,
      );
      return [];
    }
  };

  const fetchTagsForCategories = async (categories: Categories[]) => {
    const tagsData: { [key: string]: Tags[] } = {};
    for (const category of categories) {
      const fetchedTags = await getTags(category.slug);
      tagsData[category.name] = fetchedTags;
    }
    setTags(tagsData);
  };

  const toggleItem = (id: string) => {
    setActiveItem((prev) => (prev === id ? null : id));
  };

  useEffect(() => {
    getCategories();
  }, []);

  return (
    <>
      <div className="mx-auto h-auto w-full pt-10 md:pb-[50px] md:pt-[80px] pb-0 relative bg-[#0C1F33]">
        <div className="lg:container mx-auto px-5 lg:px-6 xl:px-10 2xl:px-0 z-10 relative text-[#030F1C] md:block hidden">
          <div className="flex flex-wrap md:gap-5 gap-[20px] pb-[45px] text-white">
            {categories.map((category) =>
              tags[category.name]?.length > 0
                ? tags[category.name]?.map((tag) => (
                    <div
                      key={`${category.id}-${tag.id}`}
                      className="w-[20%] md:w-[19%] lg:w-[18.5%]"
                    >
                      <p className="text-xl font-bold">
                        {category.name} - {tag.name}
                      </p>
                      <ul className="text-[#BFBFBF] mt-2">
                        {tag.pages.map((page, index) => (
                          <Link
                            key={index}
                            href={`/accounting/learn/${category.slug}/${tag.slug}/${page.slug}`}
                          >
                            <li className="text-sm pb-1 w-fit	hover:underline hover:text-[#0082F6]">
                              {page.name}
                            </li>
                          </Link>
                        ))}
                      </ul>
                    </div>
                  ))
                : null,
            )}
          </div>
        </div>

        <div className="lg:container mx-auto px-5 lg:px-6 xl:px-10 2xl:px-0 z-10 relative text-[#030F1C] block md:hidden">
          <div className="border-l border-t border-r border-[#FFFFFF61]">
            {categories.map((category) =>
              tags[category.name]?.length > 0
                ? tags[category.name]?.map((tag) => (
                    <div
                      key={`${category.id}-${tag.id}`}
                      className="border-b border-[#FFFFFF61] bg-[rgba(14,31,51,0.81)]"
                    >
                      <div
                        className="px-5 py-3 flex justify-between items-center cursor-pointer"
                        onClick={() => toggleItem(`${category.id}-${tag.id}`)}
                      >
                        <p className="text-base	text-white font-semibold">
                          {category.name} - {tag.name}
                        </p>
                        <span className="text-white">
                          {activeItem === `${category.id}-${tag.id}` ? (
                            <IoIosArrowUp />
                          ) : (
                            <IoIosArrowDown />
                          )}
                        </span>
                      </div>
                      {activeItem === `${category.id}-${tag.id}` && (
                        <div className="px-5 pb-2">
                          <ul className="text-[#BFBFBF]">
                            {tag.pages.map((page, index) => (
                              <Link
                                key={index}
                                href={`/accounting/learn/${category.slug}/${tag.slug}/${page.slug}`}
                              >
                                <li key={index}>
                                  <p className="text-xs pb-1">{page.name}</p>
                                </li>
                              </Link>
                            ))}
                          </ul>
                        </div>
                      )}
                    </div>
                  ))
                : null,
            )}
          </div>
        </div>

        <div className="relative z-10">
          <div className=" w-full ">
            <div className="lg:container mx-auto 2xl:p-0 lg:p-0 xl:px-6 md:px-6 lg:px-6 px-5">
              <div className="mx-auto w-full ">
                <div className="lg:container mx-auto 2xl:px-0 xl:px-10 lg:p-0 px_5">
                  <div className="lg:pt-0 lg:pb-[15px] pb-0 pt-0 ">
                    <div className=" md:justify-evenly sf_regular flex-wrap md:flex hidden">
                      <a
                        href="/about-us"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        About Us{" "}
                      </a>
                      <a
                        href="/cpa-cma-job-opportunities-india"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Careers{" "}
                      </a>
                      <a
                        href="/cpa-cma-career-success-stories-india"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Alumni
                      </a>
                      {/* <a
                        href="https://www.mileseducation.com/blogs"
                        target="_blank"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Blogs{" "}
                      </a> */}
                      <a
                        href="/us-jobs-for-accountants"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Miles US Pathway{" "}
                      </a>
                      <a
                        href="/events"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        Events{" "}
                      </a>
                      <a
                        href="/contact-us"
                        className="lg:text-[16px] lg:w-auto w-[100%] text-[18px] text-center md:text-left leading-[1.5rem] text-white sf_regular md:mt-3 mt-7 block"
                      >
                        {" "}
                        Contact Us{" "}
                      </a>
                    </div>
                    <div className="hidden">
                      <a
                        href="#"
                        className="lg:text-base text-[14px] leading-[1.5rem] text-[#000] font-normal underline decoration-solid mt-3 block"
                      >
                        US CPA Course
                      </a>
                    </div>
                    <div className="text-center hidden lg:mt-32 mt-10">
                      <p className="text-center pt-4 text-sm lg:w-auto w-full font-normal text-white">
                        © 2011 - 2024 Copyright{" "}
                        <a
                          className="underline decoration-solid text-white"
                          href="https://www.mileseducation.com/"
                          target="_blank"
                        >
                          Miles Education Private Limited
                        </a>
                      </p>
                      <p className=" text-center pt-2 text-sm lg:w-auto w-full font-normal text-white">
                        <a
                          className="underline decoration-solid text-white"
                          href="https://www.mileseducation.com/terms-and-conditions"
                          target="_blank"
                        >
                          Terms and Conditions
                        </a>
                        <span className="px-1 text-white">|</span>
                        <a
                          className="underline decoration-solid text-black"
                          href="https://www.mileseducation.com/privacy"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="md:hidden block mt-10">
              <Image
                src="/images/business/strategic-finance/footer-line-new-mobile.png"
                alt="Footer"
                className="mx-auto"
                width={328}
                height={1}
                priority
              />
            </div>
            <div className="lg:container md:mx-auto 2xl:p-0 lg:p-0 xl:px-10 md:px-6 md:mt-0 mt-0 lg:px-6 mx-5">
              <div className="hidden md:block pl-6 ">
                <Image
                  src="/images/business/strategic-finance/footer-line-new.png"
                  alt="Footer"
                  className="mx-auto"
                  width={1300}
                  height={1}
                  priority
                />
              </div>

              <div className=" flex w-full lg:pt-10 lg:pb-[20px] md:pt-8 md:pb-0 pb-10 justify-between flex-wrap items-center md:flex-row flex-col-reverse">
                <div className="flex md:flex-nowrap flex-wrap md:justify-start justify-center md:mt-0 mt-2">
                  <p className="md:text-left"></p>
                  <div className="lg:text-[16px] md:text-[16px] text-[10px] md:leading-[1rem] leading-[12px] md:order-1 order-2 text-white md:mt-0 mt-2 text-center lg:w-auto md:w-auto w-full md:pl-6">
                    <a
                      href="/terms-and-conditions"
                      className=" text-white inline-block"
                    >
                      General T&C
                    </a>
                    <span className="text-white px-2 inline-block">|</span>

                    <a href="/privacy" className=" text-white inline-block">
                      Privacy Policy
                    </a>
                    <span className="text-white px-2">|</span>
                    <a
                      href="/cookie-policy"
                      className="text-white inline-block"
                    >
                      Cookie Policy
                    </a>
                  </div>
                </div>

                <div className="md:block hidden">
                  <div className="md:flex hidden items-center lg:justify-end justify-center md:order-2 order-1 lg:w-auto md:w-auto w-full lg:mt-0 md:mt-0 mt-0">
                    <a
                      href="https://www.linkedin.com/school/mileseducation/mycompany/verification/"
                      target="_blank"
                    >
                      <Image
                        src="/images/accounting/linkw.png"
                        alt="Special Offer"
                        className="duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[24px]"
                        width={22}
                        height={26}
                      />
                    </a>
                    <a
                      href="https://www.facebook.com/Miles.Education.CPA.Review/"
                      target="_blank"
                      className=""
                    >
                      <Image
                        src="/images/accounting/facew.png"
                        alt="Special Offer"
                        className="duration-300 lg:mr-8 mr-6 lg:w-[16px] w-[24px]"
                        width={28}
                        height={32}
                      />
                    </a>
                    <a
                      href="https://www.instagram.com/miles.accounting/"
                      target="_blank"
                    >
                      <Image
                        src="/images/accounting/instaw.png"
                        alt="Special Offer"
                        className="duration-300 lg:mr-8 mr-6 lg:w-[22px] w-[24px]"
                        width={22}
                        height={26}
                      />
                    </a>
                    <a
                      href="https://www.youtube.com/user/milescpareview"
                      target="_blank"
                    >
                      <Image
                        src="/images/accounting/youw.png"
                        alt="Special Offer"
                        className="duration-300 lg:mr-8 mr-6 lg:w-[24px] w-[24px]"
                        width={23}
                        height={17}
                      />
                    </a>
                    <a
                      href="https://twitter.com/mileseducation"
                      target="_blank"
                      className=""
                    >
                      <Image
                        src="/images/accounting/twitw.png"
                        alt="Special Offer"
                        className="duration-300 lg:w-[23px] w-[24px]"
                        width={24}
                        height={22}
                      />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Image
          src="/images/business/strategic-finance/footer-mount.png"
          alt="Miles"
          className="absolute bottom-0 left-0 z-0"
          width={674}
          height={452}
        />
      </div>
      <div className="flex justify-center items-center">
        {isformPopupOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-[999] lg:p-10 p-4">
            <div className="rounded-[14px] shadow-lg relative lg:w-[500px] lg:h-[auto] md:w-[500px] h-[auto] mx-auto w-[365px] bg-white lg:py-6 lg:px-9 p-4">
              <button
                onClick={closeformPopup}
                className="mt-2 text-[#878787] px-3 text-lg py-1 rounded absolute right-[10px] top-[0px] z-[9999]"
              >
                ✕
              </button>

              <div className={`lg:mt-0 md:pt-0 `}>
                <EnqueryForm
                  courseId={9}
                  darkBackground={false}
                  formType="SF Form"
                  submitButtonName="Submit"
                  successMessage={SuccessMessageType.ACCOUNTING}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default CmaFooter;
